import { render, staticRenderFns } from "./Devolucion.vue?vue&type=template&id=ea4c0532&scoped=true"
import script from "./Devolucion.vue?vue&type=script&lang=js"
export * from "./Devolucion.vue?vue&type=script&lang=js"
import style0 from "./Devolucion.vue?vue&type=style&index=0&id=ea4c0532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4c0532",
  null
  
)

export default component.exports